module.exports = __webpack_public_path__ + "img/16.7d3ef04a.jpg";